<template>
    <div>
        <b-form @submit.prevent="onSubmit" @reset.prevent="onReset" novalidate>
            <b-row>
                <b-col md="6" xl="6" sm="6">
                    <language
                        :value.sync="$v.form.language.$model"
                        :state="chkState('language')"
                        :label="`${$t('miniCurriculum.form.label.language')}`"
                    >
                        <span v-if="!$v.form.language.required">
                            {{ $t('form.validations.required') }}
                        </span>
                    </language>
                </b-col>

                <b-col md="6" xl="6" sm="6">
                    <proficiency
                        :label="
                            `${$t('miniCurriculum.form.label.proficiency')}`
                        "
                        :state="chkState('proficiency')"
                        :value.sync="$v.form.proficiency.$model"
                    >
                        <span v-if="!$v.form.proficiency.required">
                            {{ $t('form.validations.required') }}
                        </span>
                    </proficiency>
                </b-col>

                <b-col
                    md="12"
                    xl="12"
                    sm="12"
                    v-if="
                        form.language &&
                            form.language.value ==
                                $t('miniCurriculum.form.label.others')
                    "
                >
                    <label>{{
                        $t('miniCurriculum.form.label.other_languages')
                    }}</label>
                    <b-form-input
                        class="mb-4"
                        v-model="form.other_languages"
                        :value.sync="$v.form.other_languages.$model"
                        :state="chkState('other_languages')"
                    >
                        <span v-if="!$v.form.other_languages.required">
                            {{ $t('form.validations.required') }}
                        </span>
                    </b-form-input>
                </b-col>
            </b-row>

            <ButtonLoader
                class="float-right ml-1"
                type="submit"
                variant="primary"
                :disabled="btnLoader"
                :loader="btnLoader"
            >
                {{ $t('form.button.save') }}
            </ButtonLoader>
            <b-button
                class="float-right"
                variant="secondary"
                :disabled="btnLoader"
                @click="goBack"
            >
                {{ $t('form.button.cancel') }}
            </b-button>
        </b-form>
    </div>
</template>

<script>
import { Language, Proficiency } from '@/views/components/fields'
import Loader from '@/views/components/loader'
import { validationMixin } from 'vuelidate'
import notification, { danger } from '@/lib/notification'
import ButtonLoader from '@/views/components/button-loader'
import { mapperLanguageToForm } from '../mappers/mapperLanguageToForm'
import { required, requiredIf } from 'vuelidate/lib/validators'
import { mapperToOption } from '@/views/components/selects'

notification.init()

const initialState = {
    language: null,
    proficiency: null,
    other_languages: null,
}

export default {
    name: 'FormLanguage',
    components: {
        Language,
        Proficiency,
        Loader,
        ButtonLoader,
    },
    props: ['language'],
    mixins: [validationMixin],
    data() {
        return {
            form: Object.assign({}, initialState),
            btnLoader: false,
            loader: true,
        }
    },
    watch: {
        language(language) {
            this.form = mapperLanguageToForm(language, mapperToOption)
        },
    },
    computed: {
        isValid() {
            return !this.$v.form.$anyError
        },
        isDirty() {
            return this.$v.form.$anyDirty
        },
    },
    validations: {
        form: {
            language: {
                required,
            },
            proficiency: {
                required,
            },
            other_languages: {
                required: requiredIf(function(form) {
                    return (
                        form.language &&
                        form.language.value ==
                            this.$t('miniCurriculum.form.label.others')
                    )
                }),
            },
        },
    },
    methods: {
        goBack() {
            this.$router.back()
        },
        onSubmit() {
            if (this.validate()) {
                this.$nextTick(() => {
                    this.$emit(
                        'onSubmit',
                        this.form,
                        this.onReset,
                        this.isLoading
                    )
                })
            }
        },
        isLoading(state) {
            this.btnLoader = state
        },
        onReset() {
            this.form = Object.assign({}, initialState)

            this.$nextTick(() => {
                this.$v.$reset()
            })
        },
        chkState(val) {
            const field = this.$v.form[val]
            return field.$dirty ? !field.$invalid : null
        },
        validate() {
            this.$v.$touch()

            return this.isValid
        },
    },
    notificationError() {
        danger()
    },
}
</script>

<style scoped>
.btn.disabled {
    cursor: auto;
}
</style>
